import { useEffect , useState } from 'react'
import { useStore } from 'store'
import { hideLoader, showLoader } from 'store/actions/commons'
import { decodeStorage } from 'functions/storageBase64'
import { BASE_PATH_API, API_EXCEPTION, STAGE_DIRNAME } from 'constants/env'
// import OtpInput from 'react18-input-otp'
import OtpInput from 'otp-input-react';
import styles from '../styles.module.sass'
import CounterTimeOTP from '../CounterTime'
import iconSecure from 'assets/img/iconPassword.svg'

const ModuleOTP = (props) => {
    const {
        handleClose,
        phoneExist,
        event_ID,
        successOTP,
        changeEvent,
        typeEvent,
        typeMask
    } = props


    const [ , dispatch ] = useStore((state) => state.giftTable.giftTable)
    const access_token = decodeStorage('access_token')
    const profileData = decodeStorage('profileData')

    const [ smaService, setSmaService ] = useState(null)
    const [ responseWalletOTP, setResponseWalletOTP ] = useState(null)
    const [ errorResponse, setErrorResponse ] = useState(null)

    const [ respPhoneCustomer, setRespPhoneCustomer ] = useState();
    const [ registred, setRegistred ] = useState();
    const [ respPhoneTable, setRespPhoneTable ] = useState();

    // OTP Input
    const [ codigoOTP, setCodigoOTP ] = useState();
    const [ codigoInvalido, setCodigoInvalido ] = useState();
    const [ flagDisable, setFlagDisable ] = useState(true)
    
    const [ play, setPlay ] = useState(null)
    const [ reset, setReset ] = useState(null)

    const validPhoneTable = async () => {
        dispatch(showLoader());
        setErrorResponse(null)
        try {
            let URL_API
            if(STAGE_DIRNAME !== 'dev'){
                URL_API = BASE_PATH_API
                
            }else{
                URL_API = BASE_PATH_API
            }

            const response = await fetch(`${URL_API}/gift-table/v1/gift-table/${event_ID}/phone-customer`);
            const data = await response.json();
            setRespPhoneCustomer(data?.data)

        } catch (error) {
            dispatch(hideLoader());
            setErrorResponse('Internal Server Error')
            console.error('Error fetching getEventTable data:', error);
        }

    }

    const putPhoneAsignEvent = async () => {
        dispatch(showLoader());
        setErrorResponse(null)
        const token = `Bearer ${access_token}`

        try {
            let URL_API
            let CEL_PHONE

            if(STAGE_DIRNAME !== 'dev'){
                URL_API = BASE_PATH_API
                CEL_PHONE = phoneExist
                
            }else{
                URL_API = BASE_PATH_API
                CEL_PHONE = phoneExist
            }

            const payload = {
                phone_number: String(CEL_PHONE)
            }

            const header = {
                method: 'PUT',
                headers: { 
                    'Content-Type':'application/json',
                    'Authorization':  token,
                },
                body: JSON.stringify(payload)
            }

            const response = await fetch(`${URL_API}/gift-table/v1/register-wallet/${event_ID}`, header);
            const data = await response.json();
            setRespPhoneTable(data?.data)

        } catch (error) {
            dispatch(hideLoader());
            setErrorResponse('Internal Server Error')
            console.error('Error fetching getEventTable data:', error);
        }

    }

    const postSendSMS = async (typeE) => {
        dispatch(showLoader());
        setErrorResponse(null)
        setPlay(null)
        try {
            let URL_API
            let MAIL
            let CEL_PHONE
            // let ID_CLIENT
            if(STAGE_DIRNAME !== 'dev'){
                URL_API = BASE_PATH_API
                MAIL = profileData?.correo
                CEL_PHONE = phoneExist
                // ID_CLIENT = profileData?.idClaro

            }else{
                URL_API = API_EXCEPTION?.userProfile
                MAIL = 'jos@sears.com'
                CEL_PHONE = '5544684807'
                // ID_CLIENT = 0
            }

            const payload = {
                token: access_token,
                data: {
                    Correo: MAIL,
                    Telefono: CEL_PHONE,
                    // Nombre: profileData?.nombre,
                    // ApellidoP: profileData?.apellidoP,
                    // ApellidoM: profileData?.apellidoM,
                    // IdCliente: ID_CLIENT,
                    Tipo: 1,
                    // TextoMs: '',
                    // Monedero: '',
                    FmaEnvio: Number(typeE),
                    Evento: String(event_ID)
                }
            }

            const header = {
                method: 'POST',
                headers: { 'Content-Type':'application/json' },
                body: JSON.stringify(payload)
            }

            const response = await fetch(`${URL_API}/app/v1/monedero-otp/`, header);
            const data = await response.json();
            setSmaService(data?.data)
        } catch (error) {
            dispatch(hideLoader())
            setErrorResponse('Internal Server Error')
            console.error('Error fetching getEventTable data:', error);
        }
    }

    const postSendCODE = async (CODE_SMS) => {
        dispatch(showLoader());
        setErrorResponse(null)
        try {
            let URL_API
            let CEL_PHONE
            let EVENT_ID
            if(STAGE_DIRNAME !== 'dev'){
                URL_API = BASE_PATH_API
                CEL_PHONE = phoneExist
                EVENT_ID = String(event_ID)
            }else{
                URL_API = API_EXCEPTION?.userProfile
                CEL_PHONE = '5544684807'
                EVENT_ID = '0005'
            }

            const payload = {
                token: access_token,
                data: {
                    Telefono: CEL_PHONE,
                    CodMS: CODE_SMS,
                    Evento: EVENT_ID
                }
            }

            const header = {
                method: 'POST',
                headers: { 'Content-Type':'application/json' },
                body: JSON.stringify(payload)
            }

            const response = await fetch(`${URL_API}/app/v1/monedero-otp-validate/`, header);
            const data = await response.json();
            setResponseWalletOTP(data)
        } catch (error) {
            dispatch(hideLoader());
            setErrorResponse('Internal Server Error')
            console.error('Error fetching getEventTable data:', error);
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault()

        if (codigoOTP && codigoOTP?.length === 6) {
            postSendCODE(codigoOTP)
        }
    }

    const handleReenviar = () => {
        setSmaService(null)
        postSendSMS(typeEvent)
    }
    
    const handleCambiarM = () => {
        setSmaService(null)
        changeEvent()
    }

    useEffect(()=>{
        validPhoneTable()
    },[])

    useEffect(()=>{
        if(respPhoneCustomer){
            const isRegistred = respPhoneCustomer?.customer?.registred
            setRegistred(isRegistred)
        }
    },[respPhoneCustomer])
    
    useEffect(()=>{
        if(registred === true){
            dispatch(hideLoader());
            postSendSMS(typeEvent)
        }else if(registred === false){
            putPhoneAsignEvent()
        }
    },[registred])

    useEffect(()=>{
        if(respPhoneTable){
            dispatch(hideLoader());
            if(respPhoneTable?.gift_table_id){
                dispatch(hideLoader())
                postSendSMS(typeEvent)
            }
        }
    },[respPhoneTable])

    useEffect(()=>{
        if(reset){
            setPlay(null)
            setReset(null)
            setCodigoOTP()
        }
    },[reset])
    

    useEffect(()=>{
        if(smaService){
            dispatch(hideLoader());
            setPlay(true)
        }
    },[smaService])

    useEffect(()=>{
        if(responseWalletOTP){
            dispatch(hideLoader())
            if(responseWalletOTP?.metadata?.http_status === 200){
                successOTP(responseWalletOTP)
            }
            else if(responseWalletOTP?.metadata?.http_status >= 400){
                setCodigoInvalido(true)
            }
        }
    },[responseWalletOTP])

    // activa boton de validar codigo al contener los 6 digitos
    useEffect(() => {
        if (codigoOTP && codigoOTP?.length === 6) {
            setFlagDisable(false);
        }
        else {
            setFlagDisable(true);
            setCodigoInvalido(false);
        }
    }, [codigoOTP])

    const [ textType, setTextType ] = useState()
    useEffect(()=>{
        if(typeEvent === 1){
            setTextType(`Ingresa el código de verificacion de 6 dígitos que hémos enviaro al número móvil ${typeMask}`)
        }else{
            setTextType(`Ingresa el código de verificacion de 6 dígitos que hémos enviaro al correo ${typeMask}`)
        }
    },[typeEvent])

    return(
        <>
            <div className={styles?.contModal}>
                <div className={styles?.closeBtn} onClick={handleClose} aria-hidden>X</div>
                <form onSubmit={handleSubmit}>
                    <div className={styles?.contIcon}>
                        <img src={iconSecure} alt="icon" className={styles?.iconSecure} />
                    </div>
                    <h1 className={styles?.titleOTP}>Código de verificación</h1>
                    <p className={styles?.subTitleOTP}>{textType}</p>

                    <div className={styles?.contInputOTP}>
                        <span className={styles?.labelOTP}>Ingresa los 6 digitos</span>
                        <OtpInput
                            value={codigoOTP}
                            onChange={setCodigoOTP}
                            autoFocus
                            OTPLength={6}
                            otpType="number"
                            disabled={!play}
                            className={styles?.contenedorOTP}
                            inputClassName={codigoInvalido ? 'inputOTP errorActivo' : 'inputOTP'}
                        />
                        {codigoInvalido &&
                            <div className={styles?.msgError}>
                                <p>Código inválido</p>
                            </div>
                        }
                    </div>

                    <CounterTimeOTP 
                        initialTime={300}
                        play={play}
                        setReset={setReset}
                    />

                    <div 
                        className={!play ? 'btn underlineButton' : `btn ${styles?.btnDisabled}`} 
                        onClick={handleCambiarM} 
                        aria-hidden 
                    >Enviar por otro medio </div>

                    <div 
                        className={!play ? 'btn solidButton' : `btn ${styles?.btnDisabled}`} 
                        onClick={handleReenviar} 
                        aria-hidden 
                    >Reenviar código</div>
                    
                    <button 
                        className={`${styles?.buttonSuccess} btn primaryButton`}
                        type="submit"
                        aria-hidden 
                        disabled={flagDisable || !play}
                    >Verificar</button>
                </form>
            </div>
            {errorResponse
                ?   <div>{errorResponse}</div>
                : null
            }
        </>
    )
}

export default ModuleOTP